import { TOPIC_NAMES } from 'crm-message-bus/types/MessageTopics';
export const OPEN_WORKFLOW_ENROLLMENT_MODAL_HANDLER = {
  topic: TOPIC_NAMES.OPEN_WORKFLOW_ENROLLMENT_MODAL,
  type: 'MODAL',
  componentLoader: () => import('../wrappers/WorkflowEnrollmentModalWrapper')
};